import axios from 'axios'
import moment from 'moment'

const LOCAL_STORAGE_CUSTOMER = 'velocate_rs_customer'

const createCustomer = () => ({
	customerIdNumber: '',
	customerFirstName: '',
	customerLastName: '',
	customerGender: null,
	customerCompany: '',
	customerStreet: '',
	customerZipCode: '',
	customerCity: '',
	customerState: '',
	customerCountry: null,
	customerPhone: '',
	customerMobile: '',
	customerTaxId: '',
	customerEmail: '',
	customerNote: ''
})

const getCustomerFromLocalStorage = () => {
	const customer = window.localStorage.getItem(LOCAL_STORAGE_CUSTOMER)
	if (!customer) return
	try {
		return JSON.parse(customer)
	} catch (err) {}
}

const state = {
	loadingPrice: false,
	startDate: null,
	endDate: null,
	positions: [],
	total: 0,
	customer: getCustomerFromLocalStorage() || createCustomer(),
	pickUpBranch: null,
	returnBranch: null
}

const getters = {
	validDates(state) {
		let startDateValid = false
		let endDateValid = false
		if (state.pickUpBranch && state.returnBranch) {
			const pickUpHours = state.pickUpBranch.BusinessHours
			const returnHours = state.returnBranch.BusinessHours

			const startDay = moment(state.startDate).day()
			const endDay = moment(state.endDate).day()
			const startTime = parseInt(moment(state.startDate).format('HHmm'))
			const endTime = parseInt(moment(state.endDate).format('HHmm'))

			for (const hour of pickUpHours) {
				const open = parseInt(hour.open.replace(':', ''))
				const close = parseInt(hour.close.replace(':', ''))
				if (hour.day === startDay && open <= startTime && close >= startTime) {
					startDateValid = true
				}
			}
			for (const hour of returnHours) {
				const open = parseInt(hour.open.replace(':', ''))
				const close = parseInt(hour.close.replace(':', ''))
				if (hour.day === endDay && open <= endTime && close >= endTime) {
					endDateValid = true
				}
			}

			return { startDateValid, endDateValid }
		}
		return { startDateValid, endDateValid }
	}
}

const actions = {
	calculatePrice(context) {
		const positions = []
		context.state.positions.forEach(category => {
			for (let i = 0; i < category.amount; i++) {
				positions.push({
					item_category_id: category.id,
					item_major_category_id: category.item_major_category_id
				})
			}
		})
		const { startDate, endDate, pickUpBranch } = context.state
		context.commit('LOADING_PRICE')
		const promise = axios
			.post('order/calculate', {
				positions,
				startDate,
				endDate,
				branch_id: pickUpBranch.id
			})
			.then(x => x.data)
		promise
			.then(data => {
				context.commit('SET_TOTAL', data.total)
				context.commit('STOP_LOADING_PRICE')
			})
			.catch(() => {
				context.commit('STOP_LOADING_PRICE')
			})
		return promise
	},
	order(context) {
		return new Promise((resolve, reject) => {
			const positions = []
			context.state.positions.forEach(category => {
				for (let i = 0; i < category.amount; i++) {
					positions.push({
						item_category_id: category.id
					})
				}
			})
			const payload = Object.assign({}, context.state)
			payload.positions = positions
			delete payload.customer
			payload.pick_up_branch_id = payload.pickUpBranch.id
			payload.return_branch_id = payload.returnBranch.id
			delete payload.pickUpBranch
			delete payload.returnBranch
			Object.keys(context.state.customer).forEach(key => {
				payload[key] = context.state.customer[key]
			})
			payload.customerCountry = context.state.customer.customerCountry.id
			payload.customerGender = context.state.customer.customerGender.id
			axios
				.post('/order', payload)
				.then(res => {
					resolve()
				})
				.catch(reject)
		})
	}
}

const mutations = {
	SET_TIMES(state, value) {
		const { startDate, endDate } = value
		state.startDate = moment(startDate)
		state.endDate = moment(endDate)
	},
	LOADING_PRICE(state) {
		state.loadingPrice = true
	},
	STOP_LOADING_PRICE(state) {
		state.loadingPrice = false
	},
	SET_POSITIONS(state, value) {
		state.positions = value
	},
	SET_TOTAL(state, value) {
		state.total = value
	},
	SET_CUSTOMER(state, value) {
		window.localStorage.setItem(LOCAL_STORAGE_CUSTOMER, JSON.stringify(value))
		const customer = Object.assign({}, value)
		state.customer = customer
	},
	SET_LOCATIONS(state, value) {
		state.pickUpBranch = value.pickUpBranch
		state.returnBranch = value.returnBranch
	},
	RESET_POSITIONS(state) {
		state.positions = []
		state.total = 0
	},
	RESET(state) {
		const today = new Date()
		today.setDate(today.getDate() + 1)
		today.setHours(9)
		today.setMinutes(0)
		const todayPlusOneWeek = new Date()
		todayPlusOneWeek.setDate(todayPlusOneWeek.getDate() + 7)
		todayPlusOneWeek.setHours(19)
		todayPlusOneWeek.setMinutes(0)

		state.startDate = today
		state.endDate = todayPlusOneWeek

		state.positions = []
		state.total = 0

		state.pickUpBranch = null
		state.returnBranch = null
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
